import { Box, Link } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { colors } from '../theme'
import { LEGAL_DOCUMENTS } from '../content/legal'

interface LegalFooterProps {
  /** `onDark` for the sign-in gradient, `onLight` everywhere else. */
  tone?: 'onLight' | 'onDark'
  sx?: SxProps<Theme>
}

/**
 * The three legal documents as one row of links. It is the single place their
 * order and labels are set, so every page that carries it stays in step.
 */
export default function LegalFooter({ tone = 'onLight', sx }: LegalFooterProps) {
  const { pathname } = useLocation()
  const onDark = tone === 'onDark'

  return (
    <Box
      component="nav"
      aria-label="Legal"
      sx={[
        {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          columnGap: 2.5,
          rowGap: 0,
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {LEGAL_DOCUMENTS.map((doc) => {
        const current = pathname === doc.path
        return (
          <Link
            key={doc.path}
            component={RouterLink}
            to={doc.path}
            underline="hover"
            aria-current={current ? 'page' : undefined}
            sx={{
              typography: 'body2',
              display: 'inline-block',
              py: 1.25,
              color: onDark ? colors.gray300 : colors.gray600,
              fontWeight: current ? 600 : 400,
              '&:hover': { color: onDark ? 'common.white' : colors.gray900 },
            }}
          >
            {doc.title}
          </Link>
        )
      })}
    </Box>
  )
}
